/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { OnChanges } from '@angular/core';

/**
 * @export
 * @class LmsLocoAssignmentComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-assignment',
  templateUrl: './lms-loco-assignment.component.html',
  styleUrls: ['./lms-loco-assignment.component.scss']
})
export class LmsLocoAssignmentComponent implements OnInit, OnDestroy, OnChanges {

  @Input() locoData: LocoDetail;
  @Input() locoLabel: any;
  intendedUsageCode: string;
  intendedUsageValue: string;
  intendedUsageReason: string;
  intendedUsageNote: string;
  qualifierValue: string;
  /**
   * Creates an instance of LmsLocoAssignmentComponent.
   *
   * @memberOf LmsLocoAssignmentComponent
   */
  constructor(public appUtilityService: AppUtilityService) { }

  /**
   * @memberOf LmsLocoAssignmentComponent
   */
  ngOnInit() {
    if (this.locoData) {
      this.intendedUsageCode = this.locoData.intendedUsageCode;
      this.intendedUsageValue = this.getIntendedUsageCode(this.locoData.intendedUsageCode);
      this.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(this.locoData.intendedUsageReason);
      this.intendedUsageNote = this.locoData.intendedUsageNote;
      this.qualifierValue = this.appUtilityService.getQulifierValue(this.locoData);
    }
  }

  /**
   * Called when state of lifecycle hook changed.
   * @memberof LmsLocoAssignmentComponent
   */
  ngOnChanges() {
    if (this.locoData) {
      this.intendedUsageCode = this.locoData.intendedUsageCode;
      this.intendedUsageValue = this.getIntendedUsageCode(this.locoData.intendedUsageCode);
      this.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(this.locoData.intendedUsageReason);
      this.intendedUsageNote = this.locoData.intendedUsageNote;
      this.qualifierValue = this.appUtilityService.getQulifierValue(this.locoData);
    }
  }

  /**
   * This method returns dash only when all the values given are null or blank
   * @param {string[]} value
   * @returns
   * @memberOf LmsLocoAssignmentComponent
   */
  returnDash(value: string[]) {
    let isBlank: boolean;
    for (let i = 0; i < value.length; i++) {
      if (value[i]) {
        isBlank = false;
        break;
      } else {
        isBlank = true;
      }
    }
    return isBlank;
  }

  /**
   * @memberOf LmsLocoAssignmentComponent
   */
  ngOnDestroy() {
  }

  /**
   * Retrieve intended usage desc from code.
   * @param {string} code
   * @returns
   * @memberof LmsLocoAssignmentComponent
   */
  getIntendedUsageCode(code: string) {
    let codeValue = '-';
    if (code) {
      codeValue = this.appUtilityService.getIntendedUsageDesc(code);
    }
    return codeValue;
  }

  /**
   * Get planned assignment with location.
   * @param {LocoDetail} locoData
   * @returns
   * @memberof LmsLocoAssignmentComponent
   */
  getPlannedAssignmentValue(loco: LocoDetail) {
    let returnVal = '';
    if (loco && this.appUtilityService.isPlannedLoco(loco)) {
      const planValue = this.getPlannedAssignmentLocation(loco);
      if (planValue === 'TRAIN') {
        const plannedLocation = loco.plannedLocation;
        returnVal = loco.plannedAssignment;
        if (plannedLocation && plannedLocation !== undefined && plannedLocation !== 'undefined') {
          returnVal += ' at ' + plannedLocation;
        }
      } else if (planValue === 'FOREIGNROAD') {
        const plannedLocation = loco.plannedLocation;
        if (plannedLocation) {
          returnVal = plannedLocation;
        }
        if (loco.plannedAssignment) {
          returnVal += ' at ' + loco.plannedAssignment;
        }
      } else if (planValue === 'TERMINAL') {
        returnVal = loco.plannedAssignment;
      }
    }
    return returnVal && returnVal.length > 0 ? returnVal : '-';
  }
  private getPlannedAssignmentLocation(loco: LocoDetail): string {
    let returnValue = '';
    if (this.appUtilityService.isValidTrainId(loco.plannedAssignment)) {
      returnValue = 'TRAIN';
    } else if (this.appUtilityService.isMnemonicExist(loco.plannedAssignment)) {
      if (loco.plannedLocation) {
        returnValue = 'FOREIGNROAD';
      } else {
        returnValue = 'TERMINAL';
      }
    }

    return returnValue;
  }

}
